import { Alert } from "@mui/material";

// マスタ編集がオンライン限定であることの既定の案内文。
const EDIT_UNAVAILABLE_MESSAGE = "現在オフラインです。マスタの追加・編集・削除はオンラインに復帰してから行えます。";

// オフライン時に表示するマスタ操作不可バナー。
// 整数IDマスタはオンライン限定のため、オフライン中は追加・編集・削除ができない旨を案内する。
// message を渡すと、その画面で行えない操作に合わせた案内文へ差し替えられる。
export function OfflineMasterBanner({ isOnline, message = EDIT_UNAVAILABLE_MESSAGE }: { isOnline: boolean; message?: string }) {
  if (isOnline) {
    return null;
  }
  return (
    <Alert severity="warning" sx={{ mb: 1 }}>
      {message}
    </Alert>
  );
}
